'use client';
import { Surface } from '@payments-checkout/shared/components';
import { Text } from '@stone-payments/jade';

type PlanNameProps = {
  plan: {
    name: string;
    description?: string;
    startAt: string;
    interval: string;
    cycles: number;
    totalCost: string;
  };
};

export function PlanName({ plan }: PlanNameProps) {
  return (
    <Surface backgroundColor="surface" data-testid="checkout-details">
      <Text variant="heading-xsmall" color="high">
        {plan.name}
      </Text>
      {!!plan.description && (
        <div className="pt-jade-100">
          <Text weight="medium" color="medium">
            {plan.description}
          </Text>
        </div>
      )}
    </Surface>
  );
}
